require('./custom-select.jade')
$ = require('jquery')
require('position-calculator')
_ = require("lodash")
require('bootstrap')

CustomSelectDirective = ->
  restrict: 'A'
  templateUrl: 'components/form/custom-select.jade'
  require: 'ngModel'
  scope:
    options: '=options'
    emptyValue: '=?'
    disable: '=?'
  replace: true
  link:(scope, elem, attrs, ctrl) ->
    #usually value for display is what user choose, but we can let user manually adjust it
    displayProperty = attrs.displayProperty || 'text'
    id = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now()
    elem.find(".dropdown").attr("id", id)
    $value = elem.find('button span.score')

    ctrl.$render = ->
      item = _.find scope.options, (i) ->
        i.value is ctrl.$modelValue
      $value.html(item?[displayProperty].toString() || "")

    scope.updateModel = (item) ->
      value = if item then item.value else undefined
      ctrl.$setViewValue(value)
      ctrl.$render()
      return

    scope.isSelected = (item) ->
      item.value is ctrl.$modelValue

    scope.$on('dropdownListClose', (e) ->
      elem.children('.dropdown').removeClass('open')
    )

module.exports = CustomSelectDirective





// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/custom-select-directive.coffee